/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show edges</h4>

<p>Show or hide edges.</p>
<p>In case some edges are selected, hitting the icon will hide them.</p>
<p>Hitting the icon with the Shift-key pressed will hide all edges, except for the selected ones.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>W</b>: Hide edges</li>
</ul>`;

export default function HideEdgesTooltip() {
    return h('div', { innerHTML: body });
}
